import axios from "axios";
import {environmentConfig} from "../config/enviromentConfig";
import {getBrandConfig} from "../brand";
import store from "../store";

// Helper function to map brand identifiers to Google Translate language codes
function getGoogleTranslateTarget(brandIdentifier) {
    const brandToLanguageMap = {
        'vc-za-en': 'en',           // Vodacom South Africa - English
        'mtn-nga-en': 'en',         // MTN Nigeria - English
        'mtn-cg-fr': 'fr',          // MTN Congo - French
        'mtn-ci-fr': 'fr',          // MTN Côte d'Ivoire - French
        'mtn-cmr-fr': 'fr',         // MTN Cameroon - French
        'mtn-gha-en': 'en',         // MTN Ghana - English
        'saudi-uae-en': 'en',       // Saudi UAE - English
        'demo-arabic': 'ar',        // Demo Arabic
        'demo-romanian': 'ro',      // Demo Romanian
        'ais-tai-en': 'en',         // AIS Thailand - English
        'ais-tai-tha': 'th',        // AIS Thailand - Thai
        'dtac-tai-tha': 'th',       // DTAC Thailand - Thai
        'mtn-zam-en': 'en',         // MTN Zambia - English
        'air-nga-en': 'en',         // Airtel Nigeria - English
        'ethiotel-et-en': 'en',     // Ethiotel Ethiopia - English
        'saf-ke-en': 'en',          // Safaricom Kenya - English
    };

    return brandToLanguageMap[brandIdentifier] || 'en'; // Default to English if brand not found
}

export default class GoogleTranslate {
    static async translationFormatter(text) {
        try {
            // get brand from store
            const currentBrand = store.state.brandConfig.brand || 'vc-za-en'; // Default fallback

            // Get the appropriate Google Translate target language code
            const targetLanguage = getGoogleTranslateTarget(currentBrand);
            console.log("TARGET LANG = " + targetLanguage);
            // Only translate if target language is not English (assuming source is always English)
            if (targetLanguage === 'en') {
                return text; // Return original text if target is English
            }

            const response = await axios.post(
                `https://translation.googleapis.com/language/translate/v2?key=${environmentConfig.googleTranslationApi}&q=${encodeURIComponent(text)}&target=${targetLanguage}&source=en`
            );

            return response.data.data.translations[0].translatedText;
        } catch (error) {
            console.error('Translation error:', error);
            return text; // Return original text if translation fails
        }
    }
}